export default "__VITE_ASSET__b7c0253b__"